class MiniCart {
    constructor() {
        this.ajaxLock = false;
        this.$ = jQuery;
        this.init();
    }

    init() {
        this.events();
    }

    /**
     * Method responsible for events
     * 
     */
    events() {
        let self = this;

        this.$('.mm__header_menu_wrapper .menu-icons .crt').on('click', function (e) {
            e.preventDefault();

            if (!self.$('#site-header #cart-list').hasClass('is-active')) {
                self.$('#site-header #cart-list').addClass('is-active');

                if (!self.$('#dark-bg').hasClass('is-active')) {
                    self.$('#dark-bg').addClass('is-active');
                }
            }
        });

        this.$('#site-header #cart-list .cart-list-head svg').on('click', function () {
            if (self.$('#site-header #cart-list').hasClass('is-active')) {
                self.$('#site-header #cart-list').removeClass('is-active');

                // Trigger only on mobile devices
                if (576 > self.$(window).width()) {
                    self.$('#site-header #cart-list').removeClass('is-active');
                } else {
                    if (self.$('#dark-bg').hasClass('is-active')) {
                        self.$('#dark-bg').removeClass('is-active');
                    }
                }
            }
        });

    }

}

export default MiniCart;